exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-editor-heading .icon-wrapper{display:inline-block;width:70px;padding:15px;background-color:var(--wf-primary);color:var(--wf-secondary);border-radius:15px;-moz-border-radius:15px;-webkit-border-radius:15px}.template-editor-heading h1{font-size:2.25rem;display:inline-block;color:var(--wf-primary);margin-left:1rem;vertical-align:middle}", ""]);

// exports
